export const DIRECTION_LABELS = {
  Up: 'up',
  UpRight: 'upRight',
  Right: 'right',
  DownRight: 'downRight',
  Down: 'down',
  DownLeft: 'downLeft',
  Left: 'left',
  UpLeft: 'upLeft',
} as const

export type Direction = (typeof DIRECTION_LABELS)[keyof typeof DIRECTION_LABELS]

export const ANGLE_MAP: Record<Direction, number> = {
  up: 0,
  upRight: 45,
  right: 90,
  downRight: 135,
  down: 180,
  downLeft: 225,
  left: 270,
  upLeft: 315,
}
